class frameworkModule {
    constructor(selector) {
        this.selector = selector;
        this.initShowFramework();
    }


    initShowFramework() {
        const elements = document.querySelectorAll('[data-cta-framework-name]');
        elements.forEach(element => {
            element.addEventListener("click", this.showFramework)
        });
    }

    showFramework(event) {

        const frameworkName = event.target.getAttribute("data-cta-framework-name");
        const frameworkElements = document.querySelectorAll("[data-framework-name]");
        const frameworkComponent = document.querySelectorAll("[data-framework-component-name]")

        frameworkElements.forEach(element => {
            if (frameworkName == element.getAttribute('data-framework-name')) {
                element.classList.add("c-split-content__fadeout");
                element.classList.add("u-hide");              
            }
        });

        frameworkComponent.forEach(element => {            
            if (frameworkName == element.getAttribute('data-framework-component-name')) {
                element.classList.add("c-framework__fadein");
                element.classList.remove("u-hide");
                window.setTimeout(function(){
                    element.classList.add("u-show");
                  },700);
            }
        });
    }
}

export default frameworkModule;
